export const refHandler = (field, form) => {
  if (!field.ref) {
    return true
  }else if (typeof field.ref.value == "boolean") {
    return form[field.ref.name].value !== ""
  } else {
    return field.ref.value === form[field.ref.name].value
  }
}